import { useMutation, useQueryClient } from '@tanstack/react-query'
import { publishEvent } from '@zet/analytics'
import { useToast } from '@zet/common/components/toast'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { i18n } from '@zet/localization'

import { verifyEditedDetails } from '../functions/verifyEditedDetails'

export default function useEditedDetails() {
  const toast = useToast()
  const navigation = useNavigation()
  const queryClient = useQueryClient()

  return useMutation(verifyEditedDetails, {
    onSuccess: (data) => {
      if (data?.edit) {
        toast?.show({
          intent: 'success',
          heading: i18n.t('toastMessages.success'),
          description: i18n.t('toastMessages.detailsUpdated'),
          hideAfter: 3000,
        })
        publishEvent('click_action', {
          item_name:
            'brands_list_recommendation_reconsent_edit_details_successful',
        })
        queryClient.invalidateQueries({ queryKey: ['home-widgets'] })
        queryClient.invalidateQueries(['customers'])
        queryClient.invalidateQueries(['recommendation'])
        if (navigation?.canGoBack()) navigation.goBack()
        else navigation.replace('HomeView')
      }
    },
    onError: (error: string) => {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: error,
        hideAfter: 3000,
      })
    },
  })
}
